import { Header } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth/Header";
import { useState } from "react";
import type { IChartState } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { DefaultChartWrapper } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/ChartWrapper";
import { parseRawData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth/parseRawData";
import { getChartConfig } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth/getChartConfig";
import { getInitialChartState } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/getInitialChartState";
import { Subtitle } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth/Subtitle";

export const SizeAndGrowth = () => {
    const [chartState, setChartState] = useState<IChartState>(getInitialChartState);
    return (
        <div>
            <Header
                chartState={chartState}
                setChartState={setChartState}
            />
            <Subtitle
                chartState={chartState}
                setChartState={setChartState}
            />
            <DefaultChartWrapper
                chartState={chartState}
                setChartState={setChartState}
                parseRawData={parseRawData}
                getChartConfig={getChartConfig}
            />
        </div>
    );
};
